'use client';

import { Trans } from '@lingui/macro';
import { Container, Stack, Typography } from '@mui/material';
import { Application, ButtonLink } from '@prismo-io/router';
import type { FC } from 'react';
export const PrivateProfileScreen: FC = () => {
  return (
    <Container maxWidth="sm">
      <Stack
        justifyContent="center"
        spacing={5}
        alignItems="center"
        minHeight="100vh"
      >
        <Typography variant="h1" textAlign="center">
          <Trans>Profil Privé</Trans>
        </Typography>
        <Stack spacing={3}>
          <Typography variant="h2" textAlign="center">
            <Trans>
              L'utilisateur de ce profil a choisi de le rendre privé. Vous ne
              pouvez pas y accéder. Vous pourrez le consulter lorsqu'il sera de
              nouveau public.
            </Trans>
          </Typography>
        </Stack>
        <ButtonLink
          app={Application.APP}
          path="/"
          queryParams={{ comingFrom: Application.APP }}
          prefetch={false}
          variant="contained"
          color="gradient"
          loadingOnClick
        >
          <Trans>Retourner à l'accueil</Trans>
        </ButtonLink>
      </Stack>
    </Container>
  );
};
